export default __webpack_public_path__ + "static/img_drivery_logo-97dfba34ce5033f0f74fc026abaa6de0.svg";